export interface CastRef {
  actorId: string;
  role: string;
}

export interface Drama {
  id: string;
  title: string;
  poster: string;
  gallery: string[];
  year: number;
  region: string;
  genres: string[];
  rating: number;
  duration: string;
  episodes: string;
  director: string;
  airDate: string;
  views: number;
  favorites: number;
  synopsis: string;
  cast: CastRef[];
  tags: string[];
  featured: boolean;
}

export const dramas: Drama[] = [
  {
    id: 'late-night-neon',
    title: '深夜霓虹',
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%20of%20an%20elegant%20lone%20silhouette%20by%20a%20rain-soaked%20city%20window%20at%20night%2C%20deep%20crimson%20and%20charcoal%20tones%2C%20dramatic%20rim%20lighting%2C%20film%20grain%20texture%2C%20mature%20drama%20aesthetic%2C%20atmospheric%20haze%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=drama-lnn-poster&orientation=portrait',
    gallery: [
      'https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20neon-lit%20bare%20apartment%20at%20midnight%20with%20one%20figure%20looking%20out%2C%20deep%20crimson%20glow%20and%20charcoal%20shadows%2C%20film%20grain%2C%20moody%20drama%20still%2C%20high%20detail%2C%20no%20text&width=1280&height=720&seq=drama-lnn-still-1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Cinematic%20close-up%20of%20two%20figures%20talking%20across%20a%20dim%20table%2C%20warm%20red%20lamp%20glow%2C%20shallow%20depth%20of%20field%2C%20film%20grain%2C%20mature%20drama%20still%2C%20high%20detail%2C%20no%20text&width=1280&height=720&seq=drama-lnn-still-2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Cinematic%20rainy%20street%20with%20reflected%20neon%20signs%20and%20a%20walking%20silhouette%2C%20charcoal%20and%20crimson%20palette%2C%20film%20grain%2C%20atmospheric%20night%20drama%20still%2C%20high%20detail%2C%20no%20text&width=1280&height=720&seq=drama-lnn-still-3&orientation=landscape',
    ],
    year: 2024,
    region: '中国大陆',
    genres: ['剧情', '都市'],
    rating: 8.7,
    duration: '每集24分钟',
    episodes: '20集 · 已完结',
    director: '顾长风',
    airDate: '2024-11-08',
    views: 1284000,
    favorites: 32680,
    synopsis: '深夜的城市像一块未说出口的心事。电台主播沈川在霓虹与雨声之间，偶然拾起一段被时间掩埋的旧日关系。随着每一通深夜来电的秘密被揭开，他不得不重新面对自己早已封存的过去，也让两个孤独的灵魂在凌晨三点彼此靠近。',
    cast: [
      { actorId: 'lin-che', role: '沈川' },
      { actorId: 'su-wan', role: '林晚' },
      { actorId: 'gu-yan', role: '周律' },
    ],
    tags: ['都市', '情感', '群像'],
    featured: true,
  },
  {
    id: 'red-lip-contract',
    title: '红唇契约',
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20poster%20of%20a%20glamorous%20woman%20in%20a%20deep%20red%20dress%20seen%20in%20profile%20against%20a%20dark%20studio%20backdrop%2C%20crimson%20and%20charcoal%20tones%2C%20dramatic%20key%20light%2C%20film%20grain%2C%20elegant%20mature%20drama%20aesthetic%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=drama-rlc-poster&orientation=portrait',
    gallery: [
      'https://readdy.ai/api/search-image?query=Cinematic%20luxury%20boardroom%20at%20dusk%20with%20an%20elegant%20woman%20standing%20by%20tall%20windows%2C%20crimson%20accents%20and%20charcoal%20tones%2C%20film%20grain%2C%20mature%20drama%20still%2C%20high%20detail%2C%20no%20text&width=1280&height=720&seq=drama-rlc-still-1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Cinematic%20tense%20handshake%20over%20a%20signed%20document%20on%20a%20dark%20desk%2C%20warm%20red%20light%2C%20shallow%20focus%2C%20film%20grain%2C%20mature%20drama%20still%2C%20high%20detail%2C%20no%20text&width=1280&height=720&seq=drama-rlc-still-2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Cinematic%20ballroom%20with%20elegant%20couple%20dancing%20under%20warm%20chandeliers%2C%20burgundy%20and%20gold%20tones%2C%20film%20grain%2C%20mature%20drama%20still%2C%20high%20detail%2C%20no%20text&width=1280&height=720&seq=drama-rlc-still-3&orientation=landscape',
    ],
    year: 2024,
    region: '中国大陆',
    genres: ['爱情', '都市'],
    rating: 8.4,
    duration: '每集22分钟',
    episodes: '24集 · 已完结',
    director: '叶清欢',
    airDate: '2024-09-21',
    views: 1576000,
    favorites: 41200,
    synopsis: '一场没有感情的契约婚姻，两个各怀心事的成年人。当冷静的规则遇上无法克制的心动，一纸契约开始出现裂痕。红唇之下，究竟是精算的交易，还是孤注一掷的真心。',
    cast: [
      { actorId: 'su-wan', role: '温以宁' },
      { actorId: 'lu-chen', role: '傅津' },
      { actorId: 'bai-wei', role: '程雪' },
    ],
    tags: ['情感', '契约', '商战'],
    featured: true,
  },
  {
    id: 'city-boundary',
    title: '城市边界',
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20poster%20of%20a%20man%20in%20a%20long%20coat%20standing%20on%20an%20empty%20overpass%20overlooking%20a%20glowing%20city%2C%20charcoal%20and%20deep%20red%20tones%2C%20dramatic%20lighting%2C%20film%20grain%2C%20urban%20noir%20aesthetic%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=drama-cb-poster&orientation=portrait',
    gallery: [
      'https://readdy.ai/api/search-image?query=Cinematic%20aerial%20view%20of%20a%20foggy%20city%20skyline%20at%20blue%20hour%20with%20warm%20red%20window%20lights%2C%20charcoal%20tones%2C%20film%20grain%2C%20urban%20drama%20still%2C%20high%20detail%2C%20no%20text&width=1280&height=720&seq=drama-cb-still-1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Cinematic%20interior%20of%20a%20sparse%20office%20with%20two%20figures%20in%20silhouette%20by%20a%20large%20window%2C%20charcoal%20and%20crimson%20tones%2C%20film%20grain%2C%20mature%20drama%20still%2C%20high%20detail%2C%20no%20text&width=1280&height=720&seq=drama-cb-still-2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Cinematic%20empty%20subway%20platform%20at%20night%20with%20a%20lone%20traveller%2C%20cool%20charcoal%20tones%20with%20a%20touch%20of%20red%2C%20film%20grain%2C%20moody%20drama%20still%2C%20high%20detail%2C%20no%20text&width=1280&height=720&seq=drama-cb-still-3&orientation=landscape',
    ],
    year: 2023,
    region: '中国大陆',
    genres: ['剧情', '都市'],
    rating: 8.9,
    duration: '每集26分钟',
    episodes: '18集 · 已完结',
    director: '沈屿',
    airDate: '2023-12-15',
    views: 986000,
    favorites: 28450,
    synopsis: '在城市不断扩张的边界上，有人被留下，有人被吞没。房产中介周律的每一单交易，都是一段人生的转移。当理想与现实在灰色地带交锋，他必须在体面与生存之间做出选择。',
    cast: [
      { actorId: 'gu-yan', role: '周律' },
      { actorId: 'wen-ning', role: '苏黎' },
      { actorId: 'chen-mo', role: '老陈' },
    ],
    tags: ['现实', '都市', '人性'],
    featured: true,
  },
  {
    id: 'silent-witness',
    title: '沉默的证人',
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20poster%20of%20a%20witness%20silhouette%20behind%20frosted%20glass%20with%20a%20single%20red%20light%2C%20dark%20charcoal%20tones%2C%20high%20contrast%2C%20film%20grain%2C%20suspense%20aesthetic%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=drama-sw-poster&orientation=portrait',
    gallery: [
      'https://readdy.ai/api/search-image?query=Cinematic%20dim%20interrogation%20room%20with%20a%20lone%20chair%20under%20a%20harsh%20red%20lamp%2C%20charcoal%20shadows%2C%20film%20grain%2C%20suspense%20drama%20still%2C%20high%20detail%2C%20no%20text&width=1280&height=720&seq=drama-sw-still-1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Cinematic%20rain%20on%20a%20car%20windshield%20at%20night%20with%20blurred%20red%20tail%20lights%2C%20dark%20charcoal%20tones%2C%20film%20grain%2C%20mystery%20drama%20still%2C%20high%20detail%2C%20no%20text&width=1280&height=720&seq=drama-sw-still-2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Cinematic%20evidence%20board%20covered%20in%20photographs%20and%20red%20string%20in%20a%20dark%20room%2C%20film%20grain%2C%20suspense%20drama%20still%2C%20high%20detail%2C%20no%20text&width=1280&height=720&seq=drama-sw-still-3&orientation=landscape',
    ],
    year: 2024,
    region: '韩国',
    genres: ['悬疑', '犯罪'],
    rating: 9.1,
    duration: '每集28分钟',
    episodes: '16集 · 已完结',
    director: '朴敏俊',
    airDate: '2024-08-02',
    views: 1123000,
    favorites: 39870,
    synopsis: '唯一的目击者，却选择永远沉默。当一桩看似普通的案件牵出盘根错节的利益网络，年轻检察官必须在一个说谎的城市里，找出那个最不敢开口的人。真相，往往是最昂贵的沉默。',
    cast: [
      { actorId: 'chen-mo', role: '陆沉' },
      { actorId: 'he-man', role: '姜叙' },
      { actorId: 'ji-ang-feng', role: '白越' },
    ],
    tags: ['悬疑', '犯罪', '反转'],
    featured: false,
  },
  {
    id: 'rose-apartment',
    title: '玫瑰公寓',
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20poster%20of%20an%20elegant%20woman%20with%20a%20single%20red%20rose%20in%20a%20dim%20vintage%20apartment%2C%20burgundy%20and%20charcoal%20tones%2C%20soft%20window%20light%2C%20film%20grain%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=drama-ra-poster&orientation=portrait',
    gallery: [
      'https://readdy.ai/api/search-image?query=Cinematic%20vintage%20apartment%20interior%20with%20warm%20amber%20lamps%20and%20red%20accents%2C%20film%20grain%2C%20mature%20drama%20still%2C%20high%20detail%2C%20no%20text&width=1280&height=720&seq=drama-ra-still-1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Cinematic%20three%20women%20in%20elegant%20evening%20dresses%20talking%20in%20a%20dim%20lounge%2C%20burgundy%20and%20gold%20tones%2C%20film%20grain%2C%20drama%20still%2C%20high%20detail%2C%20no%20text&width=1280&height=720&seq=drama-ra-still-2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Cinematic%20close-up%20of%20a%20red%20rose%20petal%20falling%20onto%20a%20written%20letter%2C%20warm%20dark%20tones%2C%20film%20grain%2C%20mature%20drama%20still%2C%20high%20detail%2C%20no%20text&width=1280&height=720&seq=drama-ra-still-3&orientation=landscape',
    ],
    year: 2023,
    region: '中国大陆',
    genres: ['剧情', '爱情'],
    rating: 8.2,
    duration: '每集25分钟',
    episodes: '22集 · 已完结',
    director: '何曼',
    airDate: '2023-10-19',
    views: 864000,
    favorites: 24780,
    synopsis: '一栋老式公寓，三个年龄迥异的女人。她们在各自的屋檐下藏着秘密、欲望与不甘。当一封没有署名的信被投进信箱，平静的生活开始泛起涟漪，也让彼此成为对方唯一的救赎。',
    cast: [
      { actorId: 'bai-wei', role: '玫瑰' },
      { actorId: 'wen-ning', role: '梁珊' },
      { actorId: 'su-wan', role: '小满' },
    ],
    tags: ['女性', '群像', '情感'],
    featured: true,
  },
  {
    id: 'dangerous-liaison',
    title: '危险关系',
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20poster%20of%20a%20man%20and%20woman%20standing%20opposite%20each%20other%20in%20shadow%20with%20a%20thin%20line%20of%20red%20light%20between%20them%2C%20charcoal%20and%20crimson%20tones%2C%20film%20grain%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=drama-dl-poster&orientation=portrait',
    gallery: [
      'https://readdy.ai/api/search-image?query=Cinematic%20elegant%20dinner%20table%20with%20two%20figures%20facing%20off%2C%20warm%20red%20candlelight%2C%20shallow%20focus%2C%20film%20grain%2C%20mature%20drama%20still%2C%20high%20detail%2C%20no%20text&width=1280&height=720&seq=drama-dl-still-1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Cinematic%20dim%20hotel%20lobby%20with%20a%20figure%20walking%20away%2C%20deep%20charcoal%20and%20burgundy%20tones%2C%20film%20grain%2C%20mature%20drama%20still%2C%20high%20detail%2C%20no%20text&width=1280&height=720&seq=drama-dl-still-2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Cinematic%20close-up%20of%20a%20wine%20glass%20tipped%20over%20a%20white%20tablecloth%2C%20deep%20red%20tones%2C%20film%20grain%2C%20mature%20drama%20still%2C%20high%20detail%2C%20no%20text&width=1280&height=720&seq=drama-dl-still-3&orientation=landscape',
    ],
    year: 2024,
    region: '欧美',
    genres: ['爱情', '悬疑'],
    rating: 8.6,
    duration: '每集30分钟',
    episodes: '12集 · 已完结',
    director: 'J. Moreau',
    airDate: '2024-07-11',
    views: 1045000,
    favorites: 33920,
    synopsis: '一场以试探开始的情感游戏，两位势均力敌的对手。谁先动心，谁就输。可当暧昧的火线与道德的边界同时被踩碎，他们才发现，真正危险的从来不是对方，而是自己无法停下的心。',
    cast: [
      { actorId: 'lu-chen', role: '傅津' },
      { actorId: 'su-wan', role: '温以宁' },
      { actorId: 'gu-yan', role: '周律' },
    ],
    tags: ['情感', '博弈', '成人向'],
    featured: false,
  },
  {
    id: 'midnight-clinic',
    title: '午夜诊所',
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20poster%20of%20a%20doctor%20silhouette%20in%20a%20dim%20clinic%20corridor%20with%20one%20red%20emergency%20light%2C%20charcoal%20tones%2C%20film%20grain%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=drama-mc-poster&orientation=portrait',
    gallery: [
      'https://readdy.ai/api/search-image?query=Cinematic%20dim%20clinic%20at%20midnight%20with%20a%20lone%20desk%20lamp%20and%20red%20glow%2C%20charcoal%20tones%2C%20film%20grain%2C%20drama%20still%2C%20high%20detail%2C%20no%20text&width=1280&height=720&seq=drama-mc-still-1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Cinematic%20close-up%20of%20hands%20writing%20a%20prescription%20under%20warm%20light%2C%20dark%20tones%20with%20red%20accents%2C%20film%20grain%2C%20drama%20still%2C%20high%20detail%2C%20no%20text&width=1280&height=720&seq=drama-mc-still-2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Cinematic%20empty%20waiting%20room%20with%20rain%20on%20the%20windows%20at%20night%2C%20cool%20charcoal%20and%20crimson%20tones%2C%20film%20grain%2C%20drama%20still%2C%20high%20detail%2C%20no%20text&width=1280&height=720&seq=drama-mc-still-3&orientation=landscape',
    ],
    year: 2022,
    region: '中国大陆',
    genres: ['剧情', '悬疑'],
    rating: 8.0,
    duration: '每集23分钟',
    episodes: '20集 · 已完结',
    director: '顾长风',
    airDate: '2022-11-30',
    views: 742000,
    favorites: 19860,
    synopsis: '一间只在午夜营业的私人诊所，收治城市里不愿被看见的伤口。值班医生在无数个深夜迎来陌生的面孔，也一点点拼凑出自己被遗忘的往事。每个病人，都是一面照见医生的镜子。',
    cast: [
      { actorId: 'chen-mo', role: '陆沉' },
      { actorId: 'he-man', role: '姜叙' },
      { actorId: 'wen-ning', role: '苏黎' },
    ],
    tags: ['医疗', '人性', '情感'],
    featured: false,
  },
  {
    id: 'museum-lost-love',
    title: '失恋博物馆',
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20poster%20of%20a%20museum%20hall%20filled%20with%20small%20display%20cases%20under%20warm%20red%20light%2C%20charcoal%20tones%2C%20film%20grain%2C%20emotional%20aesthetic%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=drama-mll-poster&orientation=portrait',
    gallery: [
      'https://readdy.ai/api/search-image?query=Cinematic%20dim%20museum%20gallery%20of%20personal%20objects%20in%20glass%20cases%2C%20warm%20amber%20and%20red%20light%2C%20film%20grain%2C%20drama%20still%2C%20high%20detail%2C%20no%20text&width=1280&height=720&seq=drama-mll-still-1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Cinematic%20close-up%20of%20faded%20photographs%20and%20old%20letters%20on%20a%20wooden%20table%2C%20warm%20dark%20tones%2C%20film%20grain%2C%20drama%20still%2C%20high%20detail%2C%20no%20text&width=1280&height=720&seq=drama-mll-still-2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Cinematic%20lone%20visitor%20standing%20before%20an%20illuminated%20display%20case%2C%20deep%20charcoal%20and%20crimson%20tones%2C%20film%20grain%2C%20drama%20still%2C%20high%20detail%2C%20no%20text&width=1280&height=720&seq=drama-mll-still-3&orientation=landscape',
    ],
    year: 2023,
    region: '日本',
    genres: ['剧情', '爱情'],
    rating: 8.3,
    duration: '每集21分钟',
    episodes: '15集 · 已完结',
    director: '佐藤凉',
    airDate: '2023-06-24',
    views: 611000,
    favorites: 17430,
    synopsis: '每件展品背后，都是一段没能走到最后的关系。博物馆的年轻策展人收集陌生人的失恋遗物，却始终不敢面对自己那件从未捐赠的纪念品。当一位神秘的访客出现，尘封的故事终于被打开。',
    cast: [
      { actorId: 'lin-che', role: '沈川' },
      { actorId: 'bai-wei', role: '玫瑰' },
      { actorId: 'ji-ang-feng', role: '白越' },
    ],
    tags: ['治愈', '情感', '文艺'],
    featured: false,
  },
  {
    id: 'beneath-neon',
    title: '霓虹之下',
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20poster%20of%20a%20woman%20silhouette%20under%20a%20huge%20neon%20sign%20reflected%20on%20wet%20asphalt%2C%20crimson%20and%20charcoal%20tones%2C%20film%20grain%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=drama-bn-poster&orientation=portrait',
    gallery: [
      'https://readdy.ai/api/search-image?query=Cinematic%20crowded%20night%20market%20with%20neon%20signs%20and%20blurred%20figures%2C%20crimson%20and%20charcoal%20tones%2C%20film%20grain%2C%20drama%20still%2C%20high%20detail%2C%20no%20text&width=1280&height=720&seq=drama-bn-still-1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Cinematic%20rooftop%20overlooking%20a%20glowing%20city%20at%20night%20with%20a%20lone%20figure%2C%20deep%20red%20and%20charcoal%20tones%2C%20film%20grain%2C%20drama%20still%2C%20high%20detail%2C%20no%20text&width=1280&height=720&seq=drama-bn-still-2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Cinematic%20close-up%20of%20a%20woman%20in%20a%20red%20coat%20walking%20through%20a%20dark%20crowd%2C%20shallow%20focus%2C%20film%20grain%2C%20drama%20still%2C%20high%20detail%2C%20no%20text&width=1280&height=720&seq=drama-bn-still-3&orientation=landscape',
    ],
    year: 2024,
    region: '中国大陆',
    genres: ['都市', '犯罪'],
    rating: 8.5,
    duration: '每集27分钟',
    episodes: '18集 · 已完结',
    director: '叶清欢',
    airDate: '2024-05-16',
    views: 933000,
    favorites: 26910,
    synopsis: '霓虹照亮的地方，也藏着最深的阴影。女记者的调查报道触碰到了城市最深处的利益链条，而她的线人却在关键时刻消失。为了真相，她必须在光鲜与黑暗之间，独自走完这段危险的路。',
    cast: [
      { actorId: 'he-man', role: '姜叙' },
      { actorId: 'lin-che', role: '沈川' },
      { actorId: 'chen-mo', role: '陆沉' },
    ],
    tags: ['都市', '犯罪', '女性'],
    featured: true,
  },
  {
    id: 'two-faced-lover',
    title: '双面情人',
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20poster%20of%20a%20face%20split%20by%20light%20and%20deep%20red%20shadow%20suggesting%20two%20identities%2C%20charcoal%20tones%2C%20film%20grain%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=drama-tfl-poster&orientation=portrait',
    gallery: [
      'https://readdy.ai/api/search-image?query=Cinematic%20mirror%20reflection%20of%20a%20figure%20in%20a%20dim%20bedroom%20with%20red%20light%2C%20charcoal%20tones%2C%20film%20grain%2C%20drama%20still%2C%20high%20detail%2C%20no%20text&width=1280&height=720&seq=drama-tfl-still-1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Cinematic%20two%20identical%20silhouettes%20facing%20each%20other%20in%20a%20dark%20room%2C%20crimson%20accents%2C%20film%20grain%2C%20mystery%20drama%20still%2C%20high%20detail%2C%20no%20text&width=1280&height=720&seq=drama-tfl-still-2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Cinematic%20close-up%20of%20two%20hands%20almost%20meeting%20across%20a%20dark%20table%2C%20warm%20red%20glow%2C%20film%20grain%2C%20drama%20still%2C%20high%20detail%2C%20no%20text&width=1280&height=720&seq=drama-tfl-still-3&orientation=landscape',
    ],
    year: 2023,
    region: '韩国',
    genres: ['爱情', '悬疑'],
    rating: 8.8,
    duration: '每集29分钟',
    episodes: '14集 · 已完结',
    director: '崔智媛',
    airDate: '2023-09-08',
    views: 879000,
    favorites: 30240,
    synopsis: '她爱上的那个人，似乎有两个名字、两段人生。当甜蜜的恋人显露出陌生的另一面，一段看似完美的关系开始变得危险。究竟是爱人隐瞒了真相，还是她从未真正认识过他。',
    cast: [
      { actorId: 'lu-chen', role: '傅津' },
      { actorId: 'bai-wei', role: '玫瑰' },
      { actorId: 'su-wan', role: '温以宁' },
    ],
    tags: ['悬疑', '情感', '反转'],
    featured: false,
  },
  {
    id: 'last-subway',
    title: '最后一班地铁',
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20poster%20of%20a%20lone%20figure%20on%20an%20empty%20subway%20platform%20with%20red%20signal%20light%2C%20charcoal%20tones%2C%20film%20grain%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=drama-lsm-poster&orientation=portrait',
    gallery: [
      'https://readdy.ai/api/search-image?query=Cinematic%20empty%20subway%20carriage%20at%20night%20with%20warm%20red%20lights%2C%20charcoal%20tones%2C%20film%20grain%2C%20drama%20still%2C%20high%20detail%2C%20no%20text&width=1280&height=720&seq=drama-lsm-still-1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Cinematic%20tunnel%20view%20from%20a%20train%20window%20with%20streaking%20lights%2C%20deep%20red%20and%20charcoal%20tones%2C%20film%20grain%2C%20drama%20still%2C%20high%20detail%2C%20no%20text&width=1280&height=720&seq=drama-lsm-still-2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Cinematic%20close-up%20of%20a%20ticket%20held%20in%20someone%20hand%20under%20dim%20light%2C%20warm%20dark%20tones%2C%20film%20grain%2C%20drama%20still%2C%20high%20detail%2C%20no%20text&width=1280&height=720&seq=drama-lsm-still-3&orientation=landscape',
    ],
    year: 2022,
    region: '中国大陆',
    genres: ['剧情', '爱情'],
    rating: 8.1,
    duration: '每集22分钟',
    episodes: '16集 · 已完结',
    director: '沈屿',
    airDate: '2022-12-02',
    views: 588000,
    favorites: 16220,
    synopsis: '午夜零点的最后一班地铁，载着下夜班的人们驶向城市尽头。两位陌生人在同一节车厢里重复相遇，用一次次短暂的车程，交换人生里最沉重也最温柔的秘密。',
    cast: [
      { actorId: 'ji-ang-feng', role: '白越' },
      { actorId: 'wen-ning', role: '苏黎' },
      { actorId: 'lin-che', role: '沈川' },
    ],
    tags: ['治愈', '情感', '都市'],
    featured: false,
  },
  {
    id: 'peach-mystery',
    title: '蜜桃谜案',
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20poster%20of%20a%20playful%20elegant%20figure%20holding%20a%20mysterious%20key%20in%20a%20dim%20room%20with%20warm%20red%20light%2C%20charcoal%20tones%2C%20film%20grain%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=drama-pm-poster&orientation=portrait',
    gallery: [
      'https://readdy.ai/api/search-image?query=Cinematic%20quirky%20apartment%20full%20of%20clues%20and%20warm%20string%20lights%20with%20red%20accents%2C%20film%20grain%2C%20comedy%20drama%20still%2C%20high%20detail%2C%20no%20text&width=1280&height=720&seq=drama-pm-still-1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Cinematic%20two%20figures%20leaning%20over%20a%20table%20of%20papers%20under%20a%20red%20lamp%2C%20warm%20tones%2C%20film%20grain%2C%20comedy%20drama%20still%2C%20high%20detail%2C%20no%20text&width=1280&height=720&seq=drama-pm-still-2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Cinematic%20close-up%20of%20an%20old%20key%20beside%20a%20peach%20on%20a%20dark%20table%2C%20warm%20red%20tones%2C%20film%20grain%2C%20drama%20still%2C%20high%20detail%2C%20no%20text&width=1280&height=720&seq=drama-pm-still-3&orientation=landscape',
    ],
    year: 2024,
    region: '中国大陆',
    genres: ['喜剧', '悬疑'],
    rating: 7.9,
    duration: '每集20分钟',
    episodes: '20集 · 已完结',
    director: '何曼',
    airDate: '2024-04-05',
    views: 702000,
    favorites: 21560,
    synopsis: '一颗普通的蜜桃，牵出一桩啼笑皆非的谜案。过气编剧与精明房东阴差阳错组成搭子，在一连串荒诞误会里越查越偏，却也意外戳破了都市人精心包装的孤独。',
    cast: [
      { actorId: 'gu-yan', role: '周律' },
      { actorId: 'he-man', role: '姜叙' },
      { actorId: 'bai-wei', role: '玫瑰' },
    ],
    tags: ['喜剧', '轻悬疑', '都市'],
    featured: false,
  },
];

export const genreOptions: string[] = ['剧情', '爱情', '悬疑', '喜剧', '都市', '犯罪'];
export const regionOptions: string[] = ['中国大陆', '韩国', '日本', '欧美'];
export const yearOptions: number[] = [2024, 2023, 2022];